"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Collapse.default;
  }
});

var _Collapse = _interopRequireDefault(require("./Collapse"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Collapse/index.js
// module id = 203
// module chunks = 0